<!-- Class name notification-wrapper was triggering an adblocker to block the notification
  the wrapper class was updated to be message-wrapper
-->
<div
  #notificationWrapper
  [class]="
    'message-wrapper' +
    ' ' +
    type +
    ' ' +
    color +
    ' ' +
    modifier +
    ' ' +
    (this.expand ? 'expanded' : '')
  "
>
  <div class="notification-content-wrapper">
    <div
      class="notification-left-column notification-column"
      [ngSwitch]="color"
    >
      <pg-icon *ngSwitchCase="'attention'" mode="border" color="attention"
        >block</pg-icon
      >
      <pg-icon *ngSwitchCase="'warning'" mode="border" color="warning"
        >warning</pg-icon
      >
      <pg-icon *ngSwitchCase="'success'" mode="border" color="success"
        >done</pg-icon
      >
      <pg-icon *ngSwitchCase="'info'" mode="border" color="default">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path
            class="temp-info-icon-path"
            d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
          />
        </svg>
      </pg-icon>
    </div>
    <div class="notification-center-column notification-column">
      <!-- no title allowed on proximity notifications -->
      <div class="notification-center__top-row" *ngIf="this.notificationTitle">
        <ng-content
          select="pg-notification-title, [pgNotificationTitle], grit-notification-title, [gritNotificationTitle]"
        ></ng-content>
      </div>

      <div
        class="notification-center__collapsable-content"
        [@transitionDismissableContent]="displayState"
        #dismissableContent
      >
        <div class="notification-center__center-row">
          <ng-content
            select="pg-notification-body, [pgNotificationBody], grit-notification-body, [gritNotificationBody]"
          ></ng-content>
        </div>
        <div class="notification-center__bottom-row">
          <ng-content
            select="pg-notification-action, [pgNotificationAction], grit-notification-action, [gritNotificationAction]"
          ></ng-content>
        </div>
      </div>
    </div>

    <!-- no actions allowed on proximity notifications -->
    <div class="notification-right-column notification-column">
      <ng-container *ngIf="type !== 'proximity'">
        <pg-icon
          *ngIf="action === 'dismiss'; else expandIconTpl"
          color="default"
          class="action-icon action-icon__close"
          (click)="handleDismissIconClick()"
          >close</pg-icon
        >
        <ng-template #expandIconTpl>
          <pg-icon
            class="action-icon action-icon__expand"
            (click)="this.expand = !this.expand"
            color="default"
            >expand_less</pg-icon
          >
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
